import { Pipe, PipeTransform } from '@angular/core';

import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { RdsChip } from '../chips/index';

/**
 * Turn `Variable[]` into RdsChips
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsVariablesToChips'
})
export class RdsVariablesToChipsPipe<T extends Variable | VariableSummary> implements PipeTransform {
  transform(variables: Array<T>): Array<RdsChip> {
    if (!variables || !variables.length) {
      return [];
    }
    return variables.map(v => new RdsChip(v.label || v.name, v.uri || v.id));
  }
}
